// Returns true of presented with an undefined value.
export default function isUndefined(obj) {
  return obj === void 0
}



// WEBPACK FOOTER //
// ./src/isUndefined.js